import React from 'react';
import { Route, Routes } from 'react-router-dom';

import { ROUTES } from '@futrli/shared-services';
import { UILoader } from '@futrli/ui-components';

import { PredictionsNavDataControls } from '../predictions/predictions-nav-data-controls/predictions-nav-data-controls';
import { PredictionsRouterFR } from '../predictions/predictions-nav-data-controls/predictions-router-fr';
import { SidePanelContextProvider } from './side-panel';
import { usePredictionsInfoContext } from '../context/predictions-info-context';

export const ForecastContainerFR = () => {
  const { forecastReportV2: forecastReport, isLoading } = usePredictionsInfoContext();

  if (!forecastReport || isLoading) {
    return <UILoader isFull />;
  }

  return (
    <SidePanelContextProvider>
      <Routes>
        <Route
          path={`${ROUTES.PREDICTIONS}/*`}
          element={
            <PredictionsNavDataControls>
              <PredictionsRouterFR />
            </PredictionsNavDataControls>
          }
        />
      </Routes>
    </SidePanelContextProvider>
  );
};
